import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            焦点吃瓜专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            精选五大深度专题，全景式回顾娱乐圈年度热点事件
          </p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col md:flex-row rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-full md:w-[320px] lg:w-[400px] flex-shrink-0 bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover aspect-[16/9] md:aspect-auto"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5 md:p-8 flex flex-col justify-center">
                <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
                <div className="mt-4">
                  <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer">
                    查看专题详情
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}